import axios, { CancelTokenSource } from "axios";

import {
  SESSION_STORAGE_GDP_TOKEN,
  SESSION_STORAGE_TOKEN,
  SESSION_STORAGE_TOKEN_IMG,
} from "../store/actions/authActions";

export const BASE_URL = String(process.env.REACT_APP_HOST);

const api = axios.create({
  baseURL: BASE_URL,
});

api.interceptors.request.use(
  config => {
    let token = sessionStorage.getItem(SESSION_STORAGE_TOKEN);
    const employeeImgToken = sessionStorage.getItem(SESSION_STORAGE_TOKEN_IMG);

    if (!token) {
      token = sessionStorage.getItem(SESSION_STORAGE_GDP_TOKEN);
    }

    if (employeeImgToken) {
      config.headers.Authorization = `Bearer ${employeeImgToken}`;
    } else if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },

  error => {
    return Promise.reject(error);
  },
);

const isCancel = (error: Error): boolean => axios.isCancel(error);

function getCancelTokenSource(): CancelTokenSource {
  return axios.CancelToken.source();
}

export { api, isCancel, getCancelTokenSource };
